import { render, staticRenderFns } from "./CustomerBehaviorDashboard.vue?vue&type=template&id=7ee7cedc&scoped=true"
import script from "./CustomerBehaviorDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerBehaviorDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomerBehaviorDashboard.vue?vue&type=style&index=0&id=7ee7cedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee7cedc",
  null
  
)

export default component.exports